module.exports = __webpack_public_path__ + "submenu_award_1.920a39a0.png";